import React from 'react';

function Terms() {
  return (
    <div className="terms-page">
      <h1>Terms and Conditions</h1>
      <div className="terms-content">
        {/* Add your terms and conditions content here */}
        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to Cybernate. By using our services, you agree to these terms.</p>
        </section>
        <section>
          <h2>2. Use of Services</h2>
          <p>Our services are provided for your personal and non-commercial use.</p>
        </section>
        {/* Add more sections as needed */}
      </div>
    </div>
  );
}

export default Terms; 